import getO365ShellShim from '../../utils/getO365ShellShim';

export function closeFlexPane(flexPaneId: string): void {
    const shim = getO365ShellShim();
    if (shim) {
        shim.FlexPane.CloseFlexPaneForProvider(flexPaneId);
    }
}
